module.exports = __webpack_public_path__ + "img/image-(2)_thumbnail.381cf2ad.jpg";